/**
 * 全局搜索-记住相关搜索参数和筛选参数
 */
import { LOCAL_STORAGE_KEY, SEARCH_TAB_TYPE, SEARCH_SORT_TYPE, SEARCH_WORD_TYPE } from '@/constants';
import { storage } from '@/utils/storageOperateApi';

const { DEFAULT } = SEARCH_SORT_TYPE || { DEFAULT: 1 };
const SEARCH_WORD_TYPE_MAP = SEARCH_WORD_TYPE || { NORMAL: 1 };
const STORAGE_KEYS = LOCAL_STORAGE_KEY || {};
const GLOBAL_SEARCH_MIND_KEY = STORAGE_KEYS.GLOBAL_SEARCH_MIND || 'GLOBAL_SEARCH_MIND';
const GLOBAL_SEARCH_HINT_KEY = STORAGE_KEYS.GLOBAL_SEARCH_HINT || 'GLOBAL_SEARCH_HINT';

/**
 * 获取全局搜索记住的参数
 * @param {Number} tabValue 全局搜索 tabValue, 对应 SEARCH_TAB_TYPE 的值
 * @param {String} prop 要获取的属性prop sortType/filterData
 * @param {*} defaultValue 默认值
 * @returns 根据prop获取tabValue对应的值
 */
export const getSearchMind = (tabValue, prop, defaultValue) => {
  if (tabValue == undefined) return;
  if (prop === 'sortType') {
    defaultValue = defaultValue ?? DEFAULT;
  }
  if (prop === 'hideContent') {
    defaultValue = defaultValue ?? false;
  }
  if (prop === 'needParticiple') {
    defaultValue = defaultValue ?? true; // 是否开启分词，默认开启（不选中精确查询）
  }
  const storageValue = storage.get(GLOBAL_SEARCH_MIND_KEY);
  const tabObj = storageValue?.[tabValue] || {};
  const res = (prop ? tabObj[prop] : tabObj) ?? defaultValue;
  if (prop === 'searchScope') return res ? 1 : 0;
  return res;
};

/**
 * 设置全局搜索记住的参数
 * @param {Number} tabValue 全局搜索 tabValue, 对应 SEARCH_TAB_TYPE 的值
 * @param {String} prop 要设置的属性prop
 * @param {*} value 要设置的值
 */
export const setSearchMind = (tabValue, prop, value) => {
  if (tabValue == undefined || !prop) return;
  const storageValue = storage.get(GLOBAL_SEARCH_MIND_KEY) || {};
  const tabKey = Object.keys(SEARCH_TAB_TYPE).find((key) => SEARCH_TAB_TYPE[key] === tabValue);
  storageValue[tabValue] = {
    tabKey,
    ...storageValue[tabValue],
    [prop]: value
  };
  storage.set(GLOBAL_SEARCH_MIND_KEY, storageValue);
};

/**
 * 获取全局搜索记住的提示词
 * @param {String} prop 要获取的属性prop
 * @returns 根据prop获取提示词
 */
export const getSearchHint = (prop) => {
  const storageValue = storage.get(GLOBAL_SEARCH_HINT_KEY) || { wordType: SEARCH_WORD_TYPE_MAP.NORMAL };
  if (prop === 'wordType') return storageValue[prop] || SEARCH_WORD_TYPE_MAP.NORMAL;
  return prop ? storageValue?.[prop] : storageValue;
};

/**
 * 设置全局搜索记住的提示词
 * @param {String|Object} prop 要设置的属性prop. 如果为对象，则设置整个对象
 * @param {*} value 要设置的值
 */
export const setSearchHint = (prop, value) => {
  if (!prop) return;
  if (Object.prototype.toString.call(prop) === '[object Object]') {
    return storage.set(GLOBAL_SEARCH_HINT_KEY, prop);
  }
  const storageValue = storage.get(GLOBAL_SEARCH_HINT_KEY) || {};
  storageValue[prop] = value;
  storage.set(GLOBAL_SEARCH_HINT_KEY, storageValue);
};
